import React from "react";
import { Send } from "lucide-react";
import { PROJECT } from "../lib/constants";

export const Nav = () => {
    return (
        <nav
            data-testid="main-nav"
            className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-[#0a0806]/70 border-b border-white/5"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <a href="#hero" data-testid="nav-logo" className="flex items-center gap-2">
                    <span className="font-display text-2xl tracking-tight">
                        <span className="text-pink-brand">LE</span>
                        <span className="text-yellow-brand">BON</span>
                        <span className="text-pink-brand">BON</span>
                    </span>
                    <span className="font-mono-soft text-xs text-[#a19d9a] hidden sm:inline">/ $LBRON</span>
                </a>
                <div className="flex items-center gap-4">
                    <a href="#roadmap" data-testid="nav-roadmap" className="hidden md:inline text-sm text-[#a19d9a] hover:text-white transition-colors">
                        Roadmap
                    </a>
                    <a href="#how-to-buy" data-testid="nav-buy" className="hidden md:inline text-sm text-[#a19d9a] hover:text-white transition-colors">
                        How to Buy
                    </a>
                    <a
                        data-testid="nav-telegram-cta"
                        href={PROJECT.telegram}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-flex items-center gap-2 bg-pink-brand text-white px-4 py-2 text-sm font-bold uppercase tracking-wide hover:bg-yellow-brand hover:text-[#0a0806] transition-colors"
                    >
                        <Send className="w-4 h-4" />
                        Telegram
                    </a>
                </div>
            </div>
        </nav>
    );
};
